import React from 'react'
import { modals } from '@mantine/modals'
import { Image, Box, Text } from '@mantine/core'
import { notificationSuccess, notificationError } from '../Notifications'
import SearchMascot from '../../../assets/img/mascot/18.png'


export const generateInvoiceNumber = ( name, functionAPI, payload, reloadData ) => {

  const handleGenerateData = async (payload) => {
    try {
      const response = await functionAPI(payload)
      if (response.success) {
        notificationSuccess(`Generate Invoice Number Successfully`,  `Data invoice number successfully generated`)
        reloadData()
        modals.closeAll()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError(`Generate Invoice Number Error`, `${errorMessage ? errorMessage : `Cannot generate data invoice number`}`)
    }
  }

  return modals.openConfirmModal({
    centered: 'true',
    closeOnConfirm: false,
    withCloseButton: false,
    size: 'lg',
    children: (
      <Box>
        <Box ta='center'>
          <Image src={SearchMascot} fit='contain' h='180' my={20} />
          <Text fw={500} mb={4}>Are you sure you want to generate invoice ? </Text>
          <Text fw='bold' mb={14}>"{name}"</Text>
          <Text fz='sm' c='gray.6' mb={20}>Data will be permanently generated. This action cannot be undone.</Text>
        </Box>
      </Box>
    ),
    labels: { confirm: 'Generate', cancel: "Cancel" },
    confirmProps: { color: 'red' },
    onConfirm: () => handleGenerateData(payload),
  })
}
